<template>
  <div>
    <v-card flat class="mt-5">
      <v-row no-gutters class="mt-4">
        <v-col
          v-if="$vuetify.breakpoint.name != 'xs'"
          cols="12"
          md="12"
          sm="12"
          lg="12"
          xl="12"
        >
          <v-toolbar dense elevation="0">
            <v-select
              label="Filter By Action Type"
              v-model="actionFilter"
              dense
              class="mt-6"
              item-text="audit_action"
              item-value="audit_action"
              :items="actionItems"
              style="max-width: 180px"
              outlined
            ></v-select>
            <v-text-field
              v-model="search"
              label="Search"
              class="mt-6 ml-2"
              dense
              append-icon="mdi-magnify"
              style="max-width: 220px"
            ></v-text-field>
          </v-toolbar>
        </v-col>
      </v-row>
      <v-card-text>
        <v-data-table
          :headers="AuditLogsData"
          :items="AuditLogsItems"
          dense
          :loading="AuditLoading"
          :options.sync="pagination"
          @update:options="getVerifyPayPagination()"
          loading-text="Loading... Please wait"
          class="overflow-y-auto overflow"
          :height="height"
          :fixed-header="fixed"
          :search="search"
          :footer-props="{
            'items-per-page-options': [10, 15, 20, 25],
          }"
        >
          <template v-slot:[`item.action_description`]="{ item }">
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on }">
                <div class="overflow" v-on="on">
                  {{ item.action_description }}
                </div>
              </template>
              <span class="white--text">{{ item.action_description }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`no-data`]>
            <v-alert class="gradient-bg2 white--text"
              >No Data Available.</v-alert
            >
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" class="gradient-bg2 white--text">
              No records found!
            </v-alert>
          </template>
          <template v-slot:[`item.action_taken_by`]="{ item }">
            <span v-if="item.action_taken_by != undefined">{{
              item.action_taken_by
            }}</span>
            <span v-else>-</span>
          </template>

          <template v-slot:[`item.audit_timestamp`]="{ item }">
            <span v-text="get_date(item.audit_timestamp)"></span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <Overlay :overlay="overlay" />
  </div>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import { AuditLogs } from "@/graphql/queries.js";
import Overlay from "@/components/Overlay.vue";
export default {
  components: {
    Overlay,
  },
  data: () => ({
    AuditLoading: false,
    height: 0,
    fixed: true,
    overlay: false,
    search: "",
    AuditLogsData: [
      { text: "Action Time", value: "audit_timestamp" },
      { text: "Action Type", value: "audit_action" },
      { text: "Acted By", value: "action_taken_by" },
      { text: "Action Description", value: "action_description" },
    ],
    AuditLogsItems: [],
    actionFilter: "ALL",
    actionItems: [],
    AuditLogsItemsNew: [],
    next_token: "",
    pagination: {
      itemsPerPage: 99,
      page: 1,
    },
  }),
  mounted() {
    this.overlay = true;
    this.AuditLoading = true;
    this.height = window.innerHeight - 210;
    this.get_audit_logs();
  },
  watch: {
    actionFilter(val) {
      this.overlay = true;
      this.AuditLoading = true;
      if (val == "ALL") {
        this.AuditLogsItems = this.AuditLogsItemsNew;
      } else {
        this.AuditLogsItems = this.AuditLogsItemsNew.filter(
          (fil) => fil.audit_action == val
        );
      }
      this.overlay = false;
      this.AuditLoading = false;
    },
  },
  methods: {
    get_date(date) {
      const options = {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };

      let a = new Date(date * 1000).toLocaleString("en-US", options);

      // Splitting the date into components
      const [datePart, timePart] = a.split(", ");
      const [month, day, year] = datePart.split("/");

      // Reformatting to "dd/mm/yyyy HH:MM:SS" format
      return `${day}/${month}/${year} ${timePart}`;
    },
    async get_audit_logs() {
      this.overlay = true;
      this.AuditLoading = true;
      this.AuditLogsItems = [];
      try {
        await API.graphql(
          graphqlOperation(AuditLogs, {
            input: {
              organisation_id:
                this.$store.getters.get_org_details[0].organisation_id,
              limit: 100,
            },
          })
        ).then((res) => {
          this.AuditLogsItemsNew = JSON.parse(
            res.data.AuditLogs
          ).auditActions.Items;

          this.AuditLogsItems = JSON.parse(
            res.data.AuditLogs
          ).auditActions.Items;

          this.next_token = JSON.parse(res.data.AuditLogs).nextToken;
          this.actionItems = JSON.parse(
            res.data.AuditLogs
          ).auditActions.Items.filter((val) => val.audit_action);
          this.actionItems.unshift("ALL");
          this.overlay = false;
          this.AuditLoading = false;
        });
      } catch {
        this.AuditLoading = false;
        this.overlay = false;
        this.AuditLogsItems = [];
      }
    },
    async getVerifyPayPagination() {
      try {
        if (this.next_token) {
          let res = await API.graphql(
            graphqlOperation(AuditLogs, {
              input: {
                organisation_id:
                  this.$store.getters.get_org_details[0].organisation_id,
                nextToken: this.next_token,
                limit: 100,
              },
            })
          );
          if (JSON.parse(res.data.AuditLogs).auditActions.Items.length > 0) {
            var response = JSON.parse(res.data.AuditLogs).auditActions.Items;
            this.AuditLogsItems.concat(response);
            this.AuditLogsItems = this.AuditLogsItems.concat(
              JSON.parse(res.data.AuditLogs).auditActions.Items
            );

            this.next_token = JSON.parse(res.data.AuditLogs).nextToken;
            this.$forceUpdate();
          }
        }
      } catch (err) {
        //console.log(err);
        this.AuditLogsItems = [];
      }
    },
  },
};
</script>

<style></style>
